<template>
  <de-layout-content>
    <div class="header">
      <div class="img">
        <img :src="info.headImageUrl" alt="" />
      </div>
      <div class="">{{ info.name }}分析报告</div>
    </div>
    <div class="">
      <el-form :inline="true" :model="form" class="ant-advanced-search-form">
        <el-form-item label="文件名称">
          <el-input
            v-model="form.keyword"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-select v-model="form.createBy" placeholder="请选择创建人">
            <el-option
              :label="item.label"
              :value="item.value"
              :key="index"
              v-for="(item, index) in createByList"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.dataTime"
            type="date"
            placeholder="请选择日期"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.dataTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="btnOperation('search')"
            >查询</el-button
          >
          <el-button type="" @click="btnOperation('reload')">重置</el-button>
          <el-button type="primary" @click="btnOperation('upload')"
            >上传</el-button
          >
          <el-button type="success" @click="btnOperation('download')"
            >下载</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 数据列表 -->
    <div>
      <!-- <a-table
        bordered
        @change="onShowSizeChange"
        :columns="columns"
        :pagination="pagination"
        :rowKey="(record) => record.id"
        :rowSelection="{
          fixed: true,
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="dataSource"
      >
        <template slot="fileName" slot-scope="text, record">
          <a-icon type="file-pdf" style="color: #666; fontsize: 16px" />
          <span>{{ record.fileName }}</span>
        </template>
<template slot="action" slot-scope="text, record">
          <a-button
            type="primary"
            size="small"
            @click="handleOperation('share', record)"
          >
            共享
          </a-button>
          <a-button
            type="primary"
            size="small"
            @click="handleOperation('edit', record)"
          >
            重命名
          </a-button>
          <a-popconfirm
            title="确定删除吗？该操作不会撤销"
            ok-text="是"
            cancel-text="否"
            @confirm="handleOperation('delete', record)"
          >
            <a-button type="primary" danger size="small"> 删除 </a-button>
          </a-popconfirm>
        </template>
</a-table> -->

      <!-- 数据列表 -->
      <el-table
        element-loading-text="加载中"
        :data="dataSource"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
      >
        <el-table-column type="selection"> </el-table-column>
        <el-table-column
          label="文件名称"
          align="center"
          prop="fileName"
          width="400"
        />
        <el-table-column
          label="文件类型"
          align="center"
          prop="fileType"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <!-- {{
                scope.row.fileType == 1 ? "视频" : val == 2 ? "图片" : "文档"
              }} -->
              {{ getFileExtension(scope.row.filePath) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="文件大小" align="center" prop="fileSize" />

        <el-table-column label="创建时间" align="center" prop="createTime">
          <template slot-scope="scope">
            <div>
              {{
                scope.row.createTime
                  ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss")
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" prop="name" />
        <el-table-column label="所属小组" align="center" prop="groupName" />
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="">
              <el-button
                size="small"
                plain
                type="primary"
                @click="handleOperation('share', scope.row)"
                >共享</el-button
              >
              <el-button
                size="small"
                plain
                type="success"
                @click="handleOperation('edit', scope.row)"
                >重命名</el-button
              >

              <a-popconfirm
                title="确定删除吗？该操作不会撤销"
                ok-text="是"
                cancel-text="否"
                @confirm="handleOperation('delete', scope.row)"
              >
                <el-button type="danger" plain size="small"> 删除 </el-button>
              </a-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="pagination.total"
        :page.sync="pagination.current"
        :limit.sync="pagination.pageSize"
        @pagination="getList"
      />

      <!-- 重命名 -->
      <el-dialog
        title="重命名"
        :visible.sync="showRechristen"
        width="600px"
        append-to-body
      >
        <el-form ref="rechristenForm" :model="rechristenForm">
          <el-form-item
            label="文件名称:"
            label-width="100px"
            prop="fileName"
            :rules="[{ required: true, message: '请输入文件名称' }]"
          >
            <el-input
              v-model="rechristenForm.fileName"
              placeholder="请输入文件名称"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRechristen = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitRechristenForm('rechristenForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 上传报告 -->
      <el-dialog
        title="上传报告"
        :visible.sync="showUpload"
        width="600px"
        append-to-body
        :before-close="handleCloseUpbg"
      >
        <el-form ref="uploadForm" :model="uploadForm" label-width="100px">
          <el-form-item label="报告文件:" required>
            <!-- :customRequest="customRequest" -->
            <a-upload
              list-type="picture"
              :action="baseUrl + `/api/file/uploadOss`"
              :headers="headers"
              @change="handleSuccess"
              :beforeUpload="beforeUpload"
              :showUploadList="false"
            >
              <el-button
                type="primary"
                icon="el-icon-upload"
                :loading="upload_loading"
              >
                选择文件
              </el-button>

              <!-- <a-button type="primary">
                <inbox-outlined></inbox-outlined>
                选择文件
              </a-button> -->
              <div
                style="color: #1890ff; margin-top: 10px"
                v-if="uploadForm.url"
              >
                {{ uploadForm.fileName }}
              </div>
            </a-upload>
            <p class="upload_tip">
              支持格式：.rar .zip .xls .xlsx .doc .docx .pdf<br/>单个文件不能超过20MB
            </p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseUpbg">取 消</el-button>
          <el-button
            type="primary"
            :loading="buttonLoding"
            @click="submitUploadForm('rechristenForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 共享 -->
      <el-dialog
        title="谁可以看"
        :visible.sync="showShare"
        width="600px"
        append-to-body
      >
        <div class="shareBox">
          <div class="shareBoxLeft">
            <a-tree
              v-model="checkedKeys"
              checkable
              :tree-data="treeData"
              :replaceFields="{
                children: 'userList',
                title: 'userName',
                key: 'userId',
              }"
              @check="treeCheck"
            />
          </div>
          <div class="shareBoxRight">
            <div class="rightHeader">
              <div class="">
                已选{{ checkList.length }} 还能选{{ num - checkList.length }}条
                <!-- (还能选{{(checkList.length - num)}}条) -->
              </div>
              <div
                class=""
                style="color: #1c87fc; cursor: pointer"
                @click="clearData"
              >
                清空
              </div>
            </div>
            <div class="ul">
              <div class="list">
                <!-- @click="selectItem(item, index)" -->
                <div
                  :class="['li', item.isChecked ? 'active' : '']"
                  v-for="(item, index) in checkList"
                  :key="index"
                >
                  <div>{{ item.userName }}</div>
                  <div @click.stop="delData(item, index)">
                    <a-icon type="close" style="color: #666; fontsize: 16px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showShare = false">取 消</el-button>
          <el-button type="primary" @click="submitShareForm('rechristenForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </de-layout-content>
</template>

<script>
import * as API_Member from "@/api/member/member";
import moment from "moment";
import store from "@/store/index";
import { TreeSelect } from "ant-design-vue";
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const columns = [
  {
    title: "文件名称",
    dataIndex: "fileName",
    key: "fileName",
    align: "center",
    slots: { customRender: "fileName" },
  },
  {
    title: "文件类型",
    dataIndex: "fileType",
    key: "fileType",
    align: "center",
    // customRender: function (val) {
    //   return val == 1 ? "视频" : val == 2 ? "图片" : "文档";
    // },
  },
  {
    title: "文件大小",
    dataIndex: "fileSize",
    key: "fileSize",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    customRender: function (val) {
      return val ? moment(val).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    align: "center",
  },
  {
    title: "创建人",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "所属小组",
    dataIndex: "groupName",
    key: "groupName",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: 250,
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  data() {
    return {
      num: 49,
      showRechristen: false,
      showUpload: false,
      showShare: false,
      buttonLoding: false,
      baseUrl: process.env.VUE_APP_BASE_API,
      //数据分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        total: 100,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
      },
      headers: {
        system: 0,
        token: store.state.token,
      },
      columns,
      SHOW_PARENT,
      dataSource: [],
      createByList: [],
      treeData: [],
      selectedRowKeys: [], // 选中项
      checkedKeys: [],
      checkList: [],
      arrFilter: [],
      downLoadList: [],
      form: {
        dataTime: [],
      },
      rechristenForm: {},
      uploadForm: {},
      info: {},
      upload_loading:false,
    };
  },
  created() {},
  mounted() {
    this.getList();
    this.getInfo();
    this.getSportsGetAnalysisCreateByList();
    this.getMemberGetShareList();
  },
  methods: {
    moment,
    //获取数据
    getList() {
      console.log(this.form.dataTime);
      let param = {
        // memberId: this.id || 467,
        memberId: this.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.form,
        startTime: this.form.dataTime.length
          ? this.moment(this.form.dataTime[0]).valueOf()
          : "",
        endTime: this.form.dataTime.length
          ? this.moment(this.form.dataTime[1]).valueOf()
          : "",
      };
      delete param.dataTime;
      API_Member.sportsFindAnalysisPageList(param).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.dataSource = res.data.list;
          this.pagination.total = res.data.total;
        }
      });
    },
    getInfo() {
      API_Member.memberInfo(this.id).then((res) => {
        console.log(res, "res");
        this.info = res.data;
      });
    },
    getMemberGetShareList() {
      API_Member.memberGetShareList({
        memberId: this.id,
      }).then((res) => {
        if (res.code === 200) {
          res.data.forEach((item, index) => {
            item.userName = item.userType;
            item.isChecked = false;
            item.index = index;

            item.userList.forEach((cItem, cIndex) => {
              cItem.isChecked = false;
            });
          });
          this.treeData = res.data;

          // this.treeData = [
          //     {
          //         title: 'Node1',
          //         value: '0-0',
          //         key: '0-0',
          //         children: [
          //             {
          //                 title: 'Child Node1',
          //                 value: '0-0-0',
          //                 key: '0-0-0',
          //             },
          //         ],
          //     },
          //     {
          //         title: 'Node2',
          //         value: '0-1',
          //         key: '0-1',
          //         children: [
          //             {
          //                 title: 'Child Node3',
          //                 value: '0-1-0',
          //                 key: '0-1-0',
          //                 disabled: true,
          //             },
          //             {
          //                 title: 'Child Node4',
          //                 value: '0-1-1',
          //                 key: '0-1-1',
          //             },
          //             {
          //                 title: 'Child Node5',
          //                 value: '0-1-2',
          //                 key: '0-1-2',
          //             },
          //         ],
          //     },
          // ];
          console.log(this.treeData, "this.treeData");
        }
      });
    },
    getSportsGetAnalysisCreateByList() {
      API_Member.sportsGetAnalysisCreateByList({
        memberId: this.id,
      }).then((res) => {
        this.createByList = res.data.map((item, index) => {
          return {
            value: item.createBy,
            label: item.name,
          };
        });
      });
    },
    //分页事件
    onShowSizeChange(pagination, filter, sorter) {
      console.log(pagination, filter, sorter);
      this.pagination = pagination;
      this.getList();
    },
    btnOperation(type, record) {
      if (type == "search") {
        this.getList();
      }
      if (type == "reload") {
        this.form = {
          dataTime: [],
        };
        this.getList();
      }
      if (type == "upload") {
        this.showUpload = true;
        this.uploadForm = {};
      }
      if (type == "download") {
        if (!this.downLoadList.length) {
          this.$message.error("请勾选下载的数据");
          return;
        }
        this.downLoad();
      }
    },
    handleOperation(type, row) {
      console.log(type, row);
      this.rowObj = row;
      if (type === "share") {
        this.showShare = true;
      }
      if (type === "edit") {
        this.showRechristen = true;
        this.rechristenForm = {
          ...row,
        };
      }
      if (type === "delete") {
        API_Member.sportsDel({
          id: row.id,
        }).then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.getList();
          }
        });
      }
    },
    // customRequest(file) {
    //   console.log(file,'file');
    //   this.$set(this.uploadForm, "file", file.file);
    // },

    // 关闭上传报告弹窗
    handleCloseUpbg() {
      this.showUpload = false;
      this.upload_loading = false;
      this.uploadForm = {};
    },

    // 上传分析报告-选择文件上传前
    beforeUpload(file) {
      this.upload_loading = true;
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.upload_loading = false
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },

    handleSuccess(info) {
      console.log(info);
      if (info.file.status === "done") {
        this.upload_loading = false;
        this.uploadForm = info.file.response.data;
        console.log(this.uploadForm, "this.uploadForm");
      } else if (info.file.status === "error") {
        this.upload_loading = false;
        this.$message.error(`${info.file.name}上传失败.`);
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.downLoadList = selectedRows;
    },
    handleSelectionChange(val) {
      console.log(val);
      this.downLoadList = val;
    },
    downLoad() {
      console.log(this.downLoadList);
      this.downLoadList.forEach((item) => {
        console.log(item.filePath);
        this.downloadFile(item.filePath,item.fileName);
      });
    },
    downloadFile(url,fileName) {
      // const iframe = document.createElement("iframe");
      // console.log(iframe);
      // iframe.style.display = "none"; // 防止影响页面
      // iframe.style.height = 0; // 防止影响页面
      // iframe.src = url;
      // document.body.appendChild(iframe);
      // setTimeout(() => {
      //   iframe.remove();
      // }, 5 * 60 * 1000);

      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 你可以设置你想要的下载文件名
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }, 5 * 60 * 1000);
        });
    },
    submitUploadForm() {
      if (!this.uploadForm.url) {
        this.$message.error("请上传文件");
        return;
      }
      // let formData = new FormData();
      // formData.append("file", this.uploadForm.url);
      // formData.append("memberId", this.id);
      let data = {
        dataType: 1,
        fileList: [
          {
            fileName: this.uploadForm.fileName,
            filePath: this.uploadForm.url,
            fileSize: this.uploadForm.fileSize,
            videoId: "",
            videoTime: "",
          },
        ],
        fileType: 3,
        id: "",
        memberId: this.id,
        userIds: [],
      };
      this.buttonLoding = true;
      API_Member.sportsUploadFile(data)
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.showUpload = false;
            this.buttonLoding = false;
            this.getList();
          } else {
            this.$message.error("操作失败");
            this.buttonLoding = false;
          }
        })
        .catch((err) => {
          this.buttonLoding = false;
        });
    },
    submitRechristenForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          API_Member.sportsRechristen(this.rechristenForm).then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.showRechristen = false;
              this.getList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    treeCheck(checkedKeys, e) {
      console.log(checkedKeys, e);
      this.checkedKeys = checkedKeys;
      this.checkList = e.checkedNodes.map((item, index) => {
        return {
          userName: item.data.props.userName,
          userId: item.data.props.userId,
          isChecked: item.data.props.isChecked,
        };
      });
      this.checkList = this.checkList.filter((item) => item.userId);
      console.log(this.checkList);
      let filteredArr = checkedKeys.filter((item) => typeof item === "number");
      this.checkedKeys = filteredArr;
      console.log(this.checkedKeys);

      this.arrFilter = this.checkList.filter((item, index) => {
        return item.isChecked;
      });
    },
    delData(item, index) {
      this.checkList.splice(index, 1);
      this.checkedKeys.splice(index, 1);
      this.arrFilter = this.arrFilter.filter((i, idx) => {
        return item.userId !== i.userId;
      });
      this.treeData.forEach((jItem, jIndex) => {
        jItem.userList.forEach((cItem, cIndex) => {
          if (item.userId === cItem.userId) {
            cItem.isChecked = false;
          }
        });
      });
    },
    selectItem(item, index) {
      this.checkList[index].isChecked = !this.checkList[index].isChecked;
      this.treeData.forEach((jItem, jIndex) => {
        jItem.userList.forEach((cItem, cIndex) => {
          if (item.userId === cItem.userId) {
            cItem.isChecked = !cItem.isChecked;
          }
        });
      });
      this.arrFilter = this.checkList.filter((item, index) => {
        return item.isChecked;
      });
    },
    clearData() {
      this.treeData.forEach((jItem, jIndex) => {
        jItem.isChecked = false;
        jItem.userList.forEach((cItem, cIndex) => {
          cItem.isChecked = false;
        });
      });
      this.arrFilter = [];
      this.checkList = [];
      this.checkedKeys = [];
    },
    submitShareForm() {
      this.buttonLoding = true;

      // let arr = this.arrFilter
      //   .map((item, index) => {
      //     return item.userId;
      //   })
      //   .join(",");
      // console.log(arr);
      // let data = {
      //   id: this.rowObj.id,
      //   userIds: arr,
      // };

      let arr = this.checkList.map((item, index) => {
        return item.userId;
      });
      console.log(arr);
      let data = {
        id: this.rowObj.id,
        userIds: arr,
      };
      console.log(data);
      API_Member.sportsUpShare(data)
        .then((res) => {
          console.log(res);
          if (res.code === 200) this.$message.success("操作成功");
          this.showShare = false;
          this.getList();
        })
        .catch((err) => {});
    },
    getFileExtension(event) {
      const file = event;
      if (file) {
        const fileName = file;
        const extension = fileName.substring(fileName.lastIndexOf(".") + 1);
        return extension;
      }
    },
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    // num() {
    //   return this.num - this.checkList.length
    // }
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  padding: 0 22px;
  height: 60px;
  display: flex;
  align-items: center;
  // border: 1px solid #f2f2f2;
  margin-bottom: 22px;

  .img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 12px;

    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
    }
  }
}

.ant-advanced-search-form {
  padding: 24px;
  // background: #fbfbfb;
  // border-radius: 6px;
  margin-bottom: 22px;
}

.shareBox {
  display: flex;
  align-items: center;
  height: 364px;
}

.shareBox .shareBoxLeft {
  width: 263px;
  height: 100%;
  margin-right: 22px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: auto;
}

.shareBox .shareBoxRight {
  width: 250px;
  padding: 0;
  height: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: auto;
}

.shareBox .rightHeader {
  display: flex;
  align-items: center;
  padding: 0 22px;
  justify-content: space-between;
  height: 40px;
  color: #999;
  background-color: #21284b;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.ul .li {
  padding: 0 22px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #21284b;
  cursor: pointer;
  color: #999;
}

.ul .li.active {
  background: #1890ff;
  color: #fff;

  i {
    color: #fff;
  }
}
p.upload_tip {
  color: #999;
  line-height:20px;
  margin-top:10px;
}
</style>
